<tt-page *ngIf="!!page">
    <ng-container class="height-full" *ngIf="'mobile' | mediaQuery">
        <tt-card>
            <ng-container *ngTemplateOutlet="btnTabs"></ng-container>

            <ng-container *ngIf="page.bg_bspmenu_main === 'BASIS'">
                <ng-container *ngTemplateOutlet="basicInfo"></ng-container>
            </ng-container>

            <ng-container *ngIf="page.bg_bspmenu_main === 'TAB'">
                <ng-container *ngTemplateOutlet="tableAccess"></ng-container>
            </ng-container>

            <tt-editor *ngIf="page.bg_bspmenu_main === 'DOC'" class="flex-1" ttLabel="html_description_base64" [(ttModel)]="page.html_description_base64" ttHeight="100%"></tt-editor>
            <tt-button-save *ngIf="page.bg_bspmenu_main === 'FUNCTIONS'" ttText="bspmenu_makecopy" (ttClick)="copyChanges()" [ttLoading]="copying"></tt-button-save>
        </tt-card>

        <tt-grid *ngIf="page.bg_bspmenu_main === 'BASIS' && !!gridUsergroups" class="flex-1" [(ttOptions)]="gridUsergroups"></tt-grid>

        <ng-container *ngIf="page.bg_bspmenu_main === 'SUB'">
            <tt-grid *ngIf="!!gridSubscriptions" class="flex-1" [(ttOptions)]="gridSubscriptions"></tt-grid>
            <tt-grid *ngIf="!!gridSubscriptionSettings" class="flex-1" [(ttOptions)]="gridSubscriptionSettings"></tt-grid>
        </ng-container>

        <tt-grid *ngIf="page.bg_bspmenu_main === 'TAB' && !!gridTabs" class="flex-1" [(ttOptions)]="gridTabs"></tt-grid>
        <tt-grid *ngIf="page.bg_bspmenu_main === 'DOCS' && !!gridDocuments" class="flex-1" [(ttOptions)]="gridDocuments"></tt-grid>
    </ng-container>

    <ng-container class="height-full" *ngIf="['tablet', 'laptop', 'desktop'] | mediaQuery">
        <tt-card class="p-5">
            <ng-container *ngTemplateOutlet="btnTabs"></ng-container>
        </tt-card>

        <ng-container class="p-5" *ngIf="page.bg_bspmenu_main === 'BASIS'">
            <tt-divider ttRememberId="bspmenu_basis_dividers">
                <tt-divider-columns>
                    <tt-divider-pane ttSize="20">
                        <tt-card>
                            <ng-container *ngTemplateOutlet="basicInfo"></ng-container>
                        </tt-card>
                    </tt-divider-pane>

                    <tt-divider-pane ttSize="80">
                        <tt-grid *ngIf="!!gridUsergroups" class="flex-1" [(ttOptions)]="gridUsergroups"></tt-grid>
                    </tt-divider-pane>
                </tt-divider-columns>
            </tt-divider>
        </ng-container>

        <ng-container *ngIf="page.bg_bspmenu_main === 'SUB'">
            <tt-divider class="p-5" ttRememberId="bspmenu_sub_dividers">
                <tt-divider-columns>
                    <tt-divider-pane ttSize="50">
                        <tt-grid *ngIf="!!gridSubscriptions" class="flex-1" [(ttOptions)]="gridSubscriptions"></tt-grid>
                    </tt-divider-pane>

                    <tt-divider-pane ttSize="50">
                        <tt-grid *ngIf="!!gridSubscriptionSettings" class="flex-1" [(ttOptions)]="gridSubscriptionSettings"></tt-grid>
                    </tt-divider-pane>
                </tt-divider-columns>
            </tt-divider>
        </ng-container>

        <ng-container *ngIf="page.bg_bspmenu_main === 'TAB'">
            <tt-divider class="p-5" ttRememberId="bspmenu_tab_dividers">
                <tt-divider-columns>
                    <tt-divider-pane ttSize="20">
                        <tt-card>
                            <ng-container *ngTemplateOutlet="tableAccess"></ng-container>
                        </tt-card>
                    </tt-divider-pane>

                    <tt-divider-pane ttSize="80">
                        <tt-grid *ngIf="!!gridTabs" class="flex-1" [(ttOptions)]="gridTabs"></tt-grid>
                    </tt-divider-pane>
                </tt-divider-columns>
            </tt-divider>
        </ng-container>

        <tt-grid *ngIf="page.bg_bspmenu_main === 'DOCS' && !!gridDocuments" class="flex-1 p-5" [(ttOptions)]="gridDocuments"></tt-grid>

        <tt-card class="p-5" *ngIf="page.bg_bspmenu_main === 'DOC'">
            <tt-editor class="flex-1" ttLabel="html_description_base64" [(ttModel)]="page.html_description_base64" ttHeight="100%"></tt-editor>
        </tt-card>

        <tt-card class="p-5" *ngIf="page.bg_bspmenu_main === 'FUNCTIONS'">
            <tt-button-save ttText="bspmenu_makecopy" (ttClick)="copyChanges()" [ttLoading]="copying"></tt-button-save>
        </tt-card>
    </ng-container>
</tt-page>

<ng-template #btnTabs>
    <ng-container *ngIf="!!page">
        <tt-tabs [ttRememberId]="'w_bspmenu.bg_bspmenu_main.' + page.bsp_keyno" [(ttSelectedId)]="page.bg_bspmenu_main" (ttSelectedIdChange)="onTabChanged()">
            <tt-tab ttId="BASIS" ttLabel="bg_bspmenu_main_basis"></tt-tab>
            <tt-tab ttId="SUB" ttLabel="bg_bspmenu_main_sub"></tt-tab>
            <tt-tab ttId="TAB" ttLabel="bg_bspmenu_main_tab"></tt-tab>
            <tt-tab ttId="DOCS" ttLabel="bg_bspmenu_main_docs"></tt-tab>
            <tt-tab ttId="DOC" ttLabel="bg_bspmenu_main_doc"></tt-tab>
            <tt-tab ttId="FUNCTIONS" ttLabel="bg_bspmenu_main_functions"></tt-tab>
        </tt-tabs>
    </ng-container>
</ng-template>

<ng-template #basicInfo>
    <ng-container *ngIf="!!page">
        <tt-input ttLabel="bsp_keyno" [ttModel]="page.bsp_keyno" ttReadonly></tt-input>
        <tt-input-buttons ttLabel="bsp_name" [ttModel]="page.bsp_name" [ttButtons]="bspNameButtons" [ttReadonly]="true"></tt-input-buttons>
        <tt-input ttLabel="reg_by_user" [ttModel]="page.reg_by_user" ttReadonly></tt-input>
        <tt-input ttLabel="reg_datetime" [ttModel]="page.reg_datetime" ttReadonly></tt-input>
    </ng-container>
</ng-template>

<ng-template #tableAccess>
    <ng-container *ngIf="!!page">
        <tt-select ttLabel="recordright" [(ttModel)]="page.recordright_no" [ttData]="recordRights" ttDataId="item_id" ttDataName="item_name"></tt-select>
        <tt-button ttText="bspmenu_set_recordright_to_selected" (ttClick)="applyRecordRight()" ttIcon="fas fa-check"></tt-button>
    </ng-container>
</ng-template>
